import { useEffect } from "react";

export default function useIframeHeightReset(iframeRef, dynamicHeight) {
  useEffect(() => {
    if (!dynamicHeight?.value && iframeRef?.current) {
      iframeRef.current.style.height = "";
    }
  }, [dynamicHeight?.value, iframeRef]);
}
